import React, { useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { LoginForm } from '@/components/LoginForm';
import { Layout } from '@/components/Layout';
import { Dashboard } from '@/components/Dashboard';
import { ProjectsList } from '@/components/ProjectsList';
import { KanbanBoard } from '@/components/KanbanBoard';
import { GanttChart } from '@/components/GanttChart';
import { UserManagement } from '@/components/UserManagement';
import { Reports } from '@/components/Reports';
import { ActivityFeed } from '@/components/ActivityFeed';
import { CalendarIntegration } from '@/components/CalendarIntegration';
import { AdvancedSearch } from '@/components/AdvancedSearch';
import { ProjectTemplates } from '@/components/ProjectTemplates';
import { WorkflowAutomation } from '@/components/WorkflowAutomation';
import { Integrations } from '@/components/Integrations';

const Index = () => {
  const { user, isLoading } = useAuth();
  const [currentView, setCurrentView] = useState<'dashboard' | 'projects' | 'kanban' | 'gantt' | 'users' | 'reports' | 'activities' | 'calendar' | 'search' | 'templates' | 'automation' | 'integrations'>('dashboard');

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 bg-gradient-to-r from-blue-500 to-purple-600 rounded-2xl flex items-center justify-center mb-4 mx-auto">
            <span className="text-white font-bold text-2xl">PM</span>
          </div>
          <div className="mt-4 space-y-2">
            <div className="w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mx-auto"></div>
            <p className="text-gray-600">Carregando sistema...</p>
          </div>
        </div>
      </div>
    );
  }

  if (!user) {
    return <LoginForm />;
  }

  const renderCurrentView = () => {
    switch (currentView) {
      case 'dashboard':
        return <Dashboard />;
      case 'projects':
        return <ProjectsList />;
      case 'kanban':
        return <KanbanBoard />;
      case 'gantt':
        return <GanttChart />;
      case 'users':
        return <UserManagement />;
      case 'reports':
        return <Reports />;
      case 'activities':
        return <ActivityFeed />;
      case 'calendar':
        return <CalendarIntegration />;
      case 'search':
        return <AdvancedSearch />;
      case 'templates':
        return <ProjectTemplates />;
      case 'automation':
        return <WorkflowAutomation />;
      case 'integrations':
        return <Integrations />;
      default:
        return <Dashboard />;
    }
  };

  return (
    <Layout currentView={currentView} onViewChange={setCurrentView}>
      {renderCurrentView()}
    </Layout>
  );
};

export default Index;